import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, CheckCircle2, ClipboardList } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/i18n";
import { Button } from "@/components/ui/button";

/** Clases de hoy que nadie reportó: lo mismo que llega por correo en la noche,
 *  pero a la vista en el resumen del panel. */
export const UnreportedClasses = () => {
  const { t } = useI18n();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/reports/unreported-classes");
        setRows(r.data?.groups || []);
      } catch {
        setRows([]);
      }
    })();
  }, []);

  if (rows === null || rows.length === 0) {
    return (
      <div
        className="mt-6 flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm text-slate-600"
        data-testid="unreported-classes-empty"
      >
        <CheckCircle2 className="h-4 w-4 text-emerald-600" />
        {rows === null ? t("loading") : t("unreported_none")}
      </div>
    );
  }

  return (
    <div
      className="mt-6 rounded-lg border border-orange-200 bg-orange-50 p-4"
      data-testid="unreported-classes-card"
    >
      <div className="flex items-center justify-between gap-3 flex-wrap mb-3">
        <h3 className="text-sm font-semibold text-orange-900 flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 text-orange-600" />
          {t("unreported_title")}
          <span className="text-[11px] font-medium text-orange-700" data-testid="unreported-count">
            · {rows.length}
          </span>
        </h3>
        <Button asChild size="sm" variant="outline"
                className="text-orange-800 border-orange-300 hover:bg-orange-100">
          <Link to="/dashboard/attendance" data-testid="unreported-go-attendance">
            <ClipboardList className="h-4 w-4" /> {t("attendance")}
          </Link>
        </Button>
      </div>
      <ul className="space-y-1.5">
        {rows.map((g) => (
          <li
            key={g.group_id}
            className="flex items-center justify-between gap-3 text-sm bg-white border border-orange-100 rounded px-3 py-2"
            data-testid={`unreported-row-${g.group_id}`}
          >
            <span className="font-medium text-slate-800 truncate">
              {g.group_name}
              <span className="text-slate-500 font-normal"> · {g.teacher_name}</span>
            </span>
            <span className="text-xs text-slate-500 whitespace-nowrap">
              {g.time_label} · {g.students}
            </span>
          </li>
        ))}
      </ul>
      <p className="text-[11px] text-orange-800 mt-2.5">{t("unreported_hint")}</p>
    </div>
  );
};
